export default "__VITE_ASSET__BcH8spRQ__"